/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import HttpCrate from '@piwikpro/http-crate';
import RouterCrate from '@piwikpro/router-crate';
import TranslationCrate from '@piwikpro/translation-crate';
import NotificationCrate from '@piwikpro/notification-crate';
import TitleCrate from '@piwikpro/title-crate';
import ConfirmationCrate from '@piwikpro/confirmation-crate';
import CookieInformationAccount from './components/CookieInformationAccount/CookieInformationAccount';
import { CookieInformationService } from './CookieInformationService';
import reducer from './redux';
import CookieInformationRegisterForm from './components/CookieInformationRegisterForm/CookieInformationRegisterForm';
import CookieInformationIntegrationToken from './components/CookieInformationIntegrationToken/CookieInformationIntegrationToken';

@Crate({
  name: 'CookieInformationCrate',
  imports: [
    HttpCrate,
    TranslationCrate,
    ConfirmationCrate,
    RouterCrate,
    TitleCrate,
    NotificationCrate,
  ],
  components: [
    { name: 'CookieInformationAccount', provide: CookieInformationAccount },
    { name: 'CookieInformationRegisterForm', provide: CookieInformationRegisterForm },
    { name: 'CookieInformationIntegrationToken', provide: CookieInformationIntegrationToken },
  ],
  services: [
    { name: 'CookieInformationService', provide: CookieInformationService },
  ],
  reducers: {
    cookieInformation: reducer,
  },
})

export class CookieInformationCrate {}
